import { WebStorageStateStore, type UserManagerSettings } from "oidc-client-ts";

/**
 * OIDC settings for Keycloak (Authorization Code + PKCE).
 * The SPA never sees a client secret. Tokens live in localStorage so the installed
 * app keeps its session between launches (needed to sync the offline outbox).
 */
export const oidcConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: "code",
  scope: "openid profile email",
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

export const apiUrl: string = import.meta.env.VITE_API_URL;
